import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { getToken } from '@/utils/storage'
import humps from 'humps'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add Authorization header to every request, you can add other custom headers here
    if (UserModule.token) {
      config.headers.Authorization = `Bearer ${getToken()}`
    }
    // 2. 转换请求数据和参数为下划线格式
    if (config.data) {
      config.data = humps.decamelizeKeys(config.data);
    }
    if (config.params) {
      config.params = humps.decamelizeKeys(config.params);
    }

    return config
  },
  (error) => {
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // 正常返回数据（HTTP状态码为2xx时会进入这里）
    // const data = response.data
    // 如果后端有自定义的业务状态码，可以在这里处理
    // return data
    return humps.camelizeKeys(response.data) as any
  },
  (error) => {
    // 处理HTTP错误状态码
    if (error.response) {
      const { status, data } = error.response
      const errorMsg = (data && data.error) || error.message || 'Error'

      // 处理不同的HTTP状态码
      if (status === 401) {
        // 401: 未授权，需要重新登录
        MessageBox.confirm('您已登出，可以取消继续留在该页面，或者重新登录', '确认登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          UserModule.ResetToken()
          location.reload()
        })
      } else if (status === 403) {
        // 403: 禁止访问
        Message({
          message: errorMsg || '您没有权限访问该资源',
          type: 'error',
          duration: 5 * 1000
        })
      } else if (status === 404) {
        // 404: 资源不存在
        Message({
          message: errorMsg || '请求的资源不存在',
          type: 'error',
          duration: 5 * 1000
        })
      } else if (status === 500) {
        // 500: 服务器错误
        Message({
          message: errorMsg || '服务器内部错误',
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        // 其他错误
        Message({
          message: errorMsg,
          type: 'error',
          duration: 5 * 1000
        })
      }
    } else {
      // 请求被取消或者网络问题
      Message({
        message: error.message || '网络错误，请检查您的网络连接',
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service
